module.exports = __webpack_public_path__ + "static/media/ic-row-add.ea809210.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table-icons/ic-row-add.svg
// module id = 822
// module chunks = 17